<template>
  <!-- if schema exists START -->
  <v-card v-if="items.length > 0">
    <v-row>
      <!-- data table START -->
      <v-col
        v-if="isNewSchema"
        class="xs"
      >
        <!-- primary key messages START -->
        <template v-if="!primaryKeyPresent">
          <v-col cols="12">
            <div class="warning--text text-center">
              <v-icon
                x-large
                color="warning"
              >
                mdi-alert
              </v-icon>
              <v-spacer />A primary key will be automatically
              generated since there is no primary key selected.
            </div>
          </v-col>
        </template>
        <!-- primary key messages START -->
      </v-col>
      <v-col cols="12">
        <v-data-table
          :headers="headers"
          :items="items"
          hide-default-footer
          class="elevation-1"
          disable-pagination
        >
          <template v-slot:item="{ item ,index}">
            <tr :class="{ 'pending-delete': !item.exists ,'text-center':true}">
              <td class="text-left">
                <v-edit-dialog
                  :disabled="!item.isNew"
                  :return-value.sync="item.updatedName"
                >
                  <v-icon
                    v-if="item.type=='foreign_key'"
                    class="pr-2"
                  >
                    mdi-link-variant
                  </v-icon>
                  <v-icon
                    v-else-if="item.primary_key"
                    class="pr-2"
                  >
                    mdi-key
                  </v-icon>
                  <span
                    v-else
                    class="pl-9"
                  />
                  <span>
                    {{ item.updatedName }}
                  </span>

                  <template v-slot:input>
                    <v-text-field
                      v-model="item.updatedName"
                      :disabled="!item.isNew"
                      :rules="[max255chars]"
                      label="Edit"
                      single-line
                      counter
                      autofocus
                    />
                  </template>
                </v-edit-dialog>
              </td>
              <td>
                <v-select
                  v-model="item.type"
                  :items="dataTypes"
                  :disabled="!isNewSchema && !item.isNew"
                />
              </td>
              <td>
                <v-checkbox
                  v-model="item.primary_key"
                  :disabled="!isNewSchema"
                  class="primary-key-row d-inline-block"
                  @change="
                    item.primary_key
                      ? (item.required = true)
                      : null
                  "
                />
              </td>
              <td class="text-center">
                <v-checkbox
                  v-model="item.required"

                  :disabled="!item.isNew || item.primary_key"
                  class="required-row d-inline-block"
                />
              </td>
              <td class="text-center">
                <v-checkbox
                  v-model="item.editable"
                  :disabled="item.primary_key"
                  class="editable-row d-inline-block"
                />
              </td>
              <td class="text-center">
                <v-checkbox
                  v-model="item.generated"
                  :disabled="!((item.type == 'uuid' || item.type == 'integer' ) && item.isNew)"
                  class="editable-row d-inline-block"
                />
              </td>
              <td>
                <template v-if="Object.keys(fieldsOptions).length>0 ">
                  <field-settings-btn
                    :options="Object.keys(fieldsOptions).includes(item.type)?fieldsOptions[item.type]:[]"
                    :dataset-name="dataset.name"
                    :dataset-id="dataset.hmd_id"
                    :disabled="!isNewSchema && !item.isNew"
                    :field="item"
                    class="mr-2"
                    @update="opts=>handleFieldOptionsUpdate(index,opts)"
                  />
                </template>
                <v-btn
                  fab
                  text
                  small
                >
                  <v-icon @click="addColumn(item)">
                    mdi-table-row-plus-after
                  </v-icon>
                </v-btn>
                <v-btn
                  fab
                  text
                  small
                  :disabled="item.primary_key"
                  @click="deleteColumn(item)"
                >
                  <v-icon>
                    {{
                      item.exists
                        ? "mdi-delete-outline"
                        : "mdi-delete-off"
                    }}
                  </v-icon>
                </v-btn>
              </td>
            </tr>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
    <v-row>
      <!-- reset button START -->
      <v-col
        class="xs pa"
        md="6"
      >
        <v-btn
          block
          large
          @click="reset"
        >
          reset schema
        </v-btn>
      </v-col>
      <!-- reset button END -->

      <!-- update button START -->
      <v-col
        class="x pa"
        md="6"
      >
        <v-btn
          block
          color="primary"
          large
          :disabled="!hasChanged"
          @click="submit"
        >
          update schema
        </v-btn>
      </v-col>
      <!-- update button END -->
    </v-row>
  </v-card>
  <!-- if schema exists END -->

  <!-- if no schema START -->
  <v-card v-else>
    <new-jumbotron
      :my-jumbotron="noSchemaJumbotron"
      :dataset="dataset"
      @createSchemaTable="createSchemaTable"
    />
  </v-card>
  <!-- if no schema END -->
</template>

<script>
/* eslint-disable no-unused-vars */
  import DatasetService from './services/DatasetService'
  import NewJumbotron from '../../../UIComponents/Jumbotron.vue'
  import FieldSettingsBtn from './FieldSettingsBtn'

  import _ from 'lodash'

  import { DATA_TYPES } from './constants/main.js'
  export default {
    $_veeValidate: {
      validator: 'new',
    },
    components: {
      FieldSettingsBtn,
      NewJumbotron,
    },
    props: {
      dataset: {
        type: Object,
        default: () => {
          return {
            hmd_id: '',
            name: '',
            description: '',
            updated_at: '',
            type: '',
          }
        },
      },
      permissions: {
        type: Array,
        default: () => {
          return []
        },
      },
    },
    data: function () {
      return {
        headers: [
          {
            text: 'Column name',
            sortable: false,
            value: 'name',
            align: 'left',
          },
          {
            text: 'Column type',
            sortable: false,
            value: 'type',
            align: 'left',
          },
          {
            text: 'Primary key',
            sortable: false,
            value: 'primary_key',
            align: 'center',
          },
          {
            text: 'Required',
            sortable: false,
            value: 'required',
            align: 'center',
          },
          {
            text: 'Editable',
            sortable: false,
            value: 'editable',
            align: 'center',
          },
          {
            text: 'Auto-generated',
            sortable: false,
            value: 'generated',
            align: 'center',
          },
          {
            text: 'Actions',
            sortable: false,
            value: 'action',
            align: 'center',
            width: 250,
          },
        ],
        items: [],
        oldFields: [],
        dataTypes: DATA_TYPES,
        noSchemaJumbotron: {
          type: 'noSchema',
          heading: "You don't have a schema yet",
          subHeading: 'Create your own schema for your dataset.',
          elementList: [
            { text: 'Choose names for your columns' },
            {
              text:
                'Decide what type of data you want (string, integer, etc.)',
            },
            { text: 'Define the primary key of your dataset' },
          ],
          dividerHeading: 'Start making your own schema now!',
        },
        isNewSchema: false,
        pkSelected: false,
        containsDuplicates: false,
        max255chars: v => v.length <= 255 || 'Name too long',
        fieldsOptions: {},
      }
    },
    computed: {
      hasChanged () {
        const rep =
          !_.isEqual(this.oldFields, this.dataset.updatedFields) ||
          this.items.length !== this.oldFields.length
        if (rep) {
          this.$emit('updateCloseConstraint', 'We have unsaved changes')
        } else {
          this.$emit('updateCloseConstraint', null)
        }
        return rep
      },
      primaryKeyPresent: function () {
        let pkPresent = false
        this.dataset.updatedFields.some(field => {
          if (field.primary_key && field.exists) {
            pkPresent = true
            return true
          }
        })
        return pkPresent
      },
    },
    mounted: function () {
      this.dataset.updatedFields = this.dataset.updatedFields.map((f, index) => {
        if (f.foreign_key) {
          f.type = 'foreign_key'
        }
        return f
      })
      this.items = this.dataset.updatedFields
      this.oldFields = _.cloneDeep(this.dataset.updatedFields)
      DatasetService.getFieldsOptions().then((result) => {
        this.fieldsOptions = result.data
      })
    },
    methods: {
      handleFieldOptionsUpdate (itemIndex, options) {
        if (this.dataset.updatedFields[itemIndex].type === 'foreign_key') {
          this.dataset.updatedFields[itemIndex].foreign_key = options
          this.dataset.updatedFields[itemIndex].constraints = undefined
        } else {
          this.dataset.updatedFields[itemIndex].constraints = options
          this.dataset.updatedFields[itemIndex].foreign_key = null
        }
      },
      addColumn (item = null) {
        var index
        index =
          item !== null
            ? this.dataset.updatedFields.findIndex(function (el) {
              return el === item
            })
            : 0
        this.dataset.updatedFields.splice(index + 1, 0, {
          name: 'column_name',
          primary_key: false,
          type: 'text',
          exists: true,
          updatedName: 'column_name',
          isNew: true,
          required: false,
          editable: true,
        })
      },
      deleteColumn (item) {
        var index = this.dataset.updatedFields.findIndex(function (el) {
          return el === item
        })
        this.dataset.updatedFields[index].exists = !this.dataset
          .updatedFields[index].exists
      },
      submit () {
        var dataset = {
          hmd_id: _.cloneDeep(this.dataset.hmd_id),
          name: _.cloneDeep(this.dataset.name),
          fields: _.cloneDeep(this.dataset.updatedFields),
        }
        _.map(dataset.fields, (df, index) => {
          if (df.type === 'foreign_key') {
            dataset.fields[index].type = 'text'
            dataset.fields[index].foreign_key_info = {
              foreign_key_reference: dataset.fields[index].foreign_key.id,
              on_delete_policy: dataset.fields[index].foreign_key.on_delete_policy,
              on_update_policy: dataset.fields[index].foreign_key.on_update_policy,
              foreign_key_type: dataset.fields[index].foreign_key.foreign_key_type,
            }
            delete dataset.fields[index].foreign_key
          }
        })
        var item
        var res = true
        // ToDo : Uncomment regex after creation regex is applied
        // var regexp = new RegExp("(^(([A-Za-zÀ-ÖØ-öø-ÿ][A-zÀ-ÖØ-öø-ÿ0-9_ \-]*)[^_|\-| ])$)")
        for (item in dataset.fields) {
          var field = dataset.fields[item]
          if (field.isNew) {
            field.name = field.updatedName
          }
          if (field.exists) {
            // ToDo : Uncomment regex after creation regex is applied
            // res = regexp.test(field.name)
          }
          if (!res && field.exists) {
            this.$store.commit('push', {
              msg:
                'error "' +
                field.name +
                '". Field can contains alphanumeric and accentued chars. ' +
                'They cannot contains special char, except whitespaces, underscores, and hyphens, but cannot end with them.',
              color: 'error',
            })
            break
          }
        }
        if (res) {
          this.checkErrors()
          if (this.containsDuplicates === false) {
            const t = this
            // The event is only emitted after the update has been succefully realized
            DatasetService.update_fields(dataset, this).then(function (
              response
            ) {
              if (response.status === 200) {
                t.$emit('schemaUpdated')
              }
            })
          }
        }
      },
      createSchemaTable () {
        this.addColumn(null)
        this.isNewSchema = true
      },
      isDeleteDisabled (currItem) {
        var nbActiveColumns = 0
        var item
        for (item in this.items) {
          if (this.items[item].exists) {
            nbActiveColumns++
          }
        }
        return (
          (currItem.primary_key === true && !this.isNewSchema) ||
          nbActiveColumns === 1
        )
      },
      checkErrors () {
        // var ans=false
        // for (item in this.items){
        //   var el = this.items[item]
        //   if(el.exists === true){
        //     ans = ans || el.primary_key
        //   }
        // }
        // this.pkSelected = ans || this.isSchema === false

        var existingValuesArray = this.items.filter(x => x.exists === true)
        var valueArr = existingValuesArray.map(function (item) {
          return item.updatedName
        })
        this.containsDuplicates = valueArr.some(function (item, idx) {
          return valueArr.indexOf(item) !== idx
        })

        // if(this.pkSelected === false){
        //   this.$store.commit('push', {msg: 'no primary key selected', color: 'error'})
        // }

        if (this.containsDuplicates === true) {
          this.$store.commit('push', {
            msg: 'The schema contains duplicated column names',
            color: 'error',
          })
        }
      },
      checkName (item) {
        if (item.updatedName.length === 0) {
          this.$store.commit('push', {
            msg: 'column name cannot be empty',
            color: 'error',
          })
          item.updatedName = item.name
        } else {
          item.updatedName = item.updatedName.toLowerCase()
        }
      },
      // Reset the schema at its initial state
      // We need forEach loops as VueJS won't update the DOM correctly if we don't use push and pop
      reset: function () {
        while (this.dataset.updatedFields.length > 0) {
          this.dataset.updatedFields.pop()
        }

        this.dataset.fields.forEach(el => {
          this.dataset.updatedFields.push(Object.assign({}, el))
        })
      },
    },
  }
</script>

<style>
.pending-delete > td > .v-icon {
    color: white;
}
.pending-delete > td {
    color: white;
    background-color: rgb(255, 85, 85) !important;
    border-top: 1px solid red !important;
    border-bottom: 1px solid red !important;
}
</style>
